import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  standalone: false,
  selector: 'app-loader',
  template: `
    @if (loaderService.loading$ | async) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center bg-[color-mix(in_srgb,var(--neutral-gray20)_60%,transparent)]">
      <div class="h-16 w-16 animate-spin rounded-full border-4 border-neutral-gray30 border-t-primary-90"></div>
    </div>
    }
  `,
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
